import React from "react";

const GasDeviceDetail = ({
  ch4,
  co2,
  o2,
  h2s,
  dewPoint,
  gcv,
  ncv,
  n2,
  lastUpdated,
}) => {
  const display = (v) => {
    if (v === null || v === undefined) return "0";
    if (typeof v === "number" && Number.isNaN(v)) return "0";
    if (typeof v === "string" && (v.trim() === "" || v === "--")) return "0";
    const n = typeof v === "number" ? v : parseFloat(v);
    if (!Number.isNaN(n) && n < 0) return "0";
    return v;
  };
  const displayDew = (v) => {
    if (v === null || v === undefined) return "--";
    if (typeof v === "number" && Number.isNaN(v)) return "--";
    if (typeof v === "string" && v.trim() === "") return "--";
    const n = typeof v === "number" ? v : parseFloat(v);
    if (!Number.isNaN(n) && n < 0) return "0";
    return v;
  };

  const cards = [
    {
      key: "ch4",
      name: "CH4",
      subtitle: "METHANE",
      icon: "🔥",
      value: display(ch4),
      unit: "% VOL",
      status: "normal",
    },
    {
      key: "co2",
      name: "CO2",
      subtitle: "CARBON DIOXIDE",
      icon: "☁️",
      value: display(co2),
      unit: "% VOL",
      status: "normal",
    },
    {
      key: "o2",
      name: "O2",
      subtitle: "OXYGEN",
      icon: "💨",
      value: display(o2),
      unit: "% VOL",
      status: "normal",
    },
    {
      key: "h2s",
      name: "H2S-L",
      subtitle: "HYDROGEN SULFIDE",
      icon: "☠️",
      value: display(h2s),
      unit: "PPM",
      status: "normal",
    },
    {
      key: "dpoint",
      name: "D-POINT",
      subtitle: "DEW POINT",
      icon: "💧",
      value: displayDew(dewPoint),
      unit: "°C",
      status: dewPoint == null || dewPoint === "--" ? "no-data" : "normal",
    },
    {
      key: "gcv",
      name: "GCV",
      subtitle: "GROSS CALORIFIC VALUE",
      icon: "🔥",
      value: display(gcv),
      unit: "",
      status: "normal",
    },
    {
      key: "ncv",
      name: "NCV",
      subtitle: "NET CALORIFIC VALUE",
      icon: "🔥",
      value: display(ncv),
      unit: "",
      status: "normal",
    },
    {
      key: "n2",
      name: "N2",
      subtitle: "NITROGEN",
      icon: "💨",
      value: display(n2),
      unit: "% VOL",
      status: "normal",
    },
  ];

  const statusStyle = (status) => {
    if (status === "warning") return { background: "#FFF8E1", color: "#EF6C00" };
    if (status === "alarm") return { background: "#FFEBEE", color: "#C62828" };
    if (status === "no-data") return { background: "#ECEFF1", color: "#90A4AE" };
    return { background: "#E8F5E9", color: "#2E7D32" };
  };
  const statusLabel = (status) =>
    status === "warning"
      ? "WARNING"
      : status === "alarm"
      ? "ALARM"
      : status === "no-data"
      ? "NO DATA"
      : "NORMAL";

  return (
    <div
      style={{
        background: "white",
        borderRadius: 24,
        padding: 28,
        boxShadow: "0 8px 24px rgba(2, 136, 209, 0.08)",
        marginTop: 20,
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
          gap: 16,
          marginBottom: 24,
        }}
      >
        {cards.map((c) => (
          <div
            key={c.key}
            style={{
              background: "white",
              border: "1px solid #E1F5FE",
              borderRadius: 16,
              padding: "20px 18px",
              display: "flex",
              flexDirection: "column",
              gap: 12,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div
                style={{
                  width: 42,
                  height: 42,
                  borderRadius: 12,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 22,
                  background: "#E1F5FE",
                  flexShrink: 0,
                }}
              >
                {c.icon}
              </div>
              <div>
                <div
                  style={{
                    fontSize: 18,
                    fontWeight: 700,
                    lineHeight: 1.1,
                    color: "#1C5E85",
                    letterSpacing: "-0.2px",
                  }}
                >
                  {c.name}
                </div>
                <div
                  style={{
                    fontSize: 10,
                    color: "#90A4AE",
                    fontWeight: 600,
                    letterSpacing: "0.6px",
                    marginTop: 2,
                  }}
                >
                  {c.subtitle}
                </div>
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "baseline", gap: 6 }}>
              <span
                style={{
                  fontSize: 34,
                  fontWeight: 700,
                  lineHeight: 1,
                  letterSpacing: "-0.5px",
                  fontVariantNumeric: "tabular-nums",
                  color: c.status === "no-data" ? "#B0BEC5" : "#09c4ff",
                }}
              >
                {c.value}
              </span>
              <span
                style={{
                  fontSize: 12,
                  color: "#607D8B",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: "0.4px",
                }}
              >
                {c.unit}
              </span>
            </div>
            <span
              style={{
                marginTop: "auto",
                padding: "4px 12px",
                borderRadius: 100,
                fontSize: 10,
                fontWeight: 700,
                letterSpacing: "1px",
                textAlign: "center",
                alignSelf: "flex-start",
                ...statusStyle(c.status),
              }}
            >
              {statusLabel(c.status)}
            </span>
          </div>
        ))}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingTop: 18,
          borderTop: "1px solid #E1F5FE",
          fontSize: 14,
          color: "#607D8B",
          flexWrap: "wrap",
          gap: 12,
        }}
      >
        <div>
          <span style={{ color: "#90A4AE", fontWeight: 500 }}>
            Last Updated:{" "}
          </span>
          <span
            style={{
              color: "#09c4ff",
              fontWeight: 600,
              fontVariantNumeric: "tabular-nums",
            }}
          >
            {lastUpdated || "--"}
          </span>
        </div>
      </div>
    </div>
  );
};

export default GasDeviceDetail;
